module.exports = __webpack_public_path__ + "img/65.9dd48b84.jpg";